import React from 'react'
import collapse from '../../assets/images/player/collapse.png'

function PlayerCollapse() {
  
  function collapsePlayer() {
    document.getElementById(`audio-player-container`).removeAttribute(`style`)
    document.getElementById(`audio-player`).removeAttribute(`style`)
    document.getElementById(`audio-player-container`).style.display = `block`
    document.getElementById(`audio-player`).style.display = `grid`
    
    document.getElementById(`player-collapse`).style.display = `none`
    document.getElementById(`player-expand`).style.display = `block`
    
    document.getElementById(`audio-player-container`).removeAttribute(`class`)
    document.getElementById(`audio-player`).removeAttribute(`class`)
    
    document.getElementById(`song-backward`).removeAttribute(`class`)
    document.getElementById(`song-forward`).removeAttribute(`class`)
    document.getElementById(`song-cover`).removeAttribute(`class`)
    document.getElementById(`song-title`).removeAttribute(`class`)
  }
  
  return (
    <button id={`player-collapse`} onClick={collapsePlayer} style={{maskImage: `url(${collapse})`, WebkitMaskImage: `url(${collapse})`, display: `none`}}>Collapse</button>
  )
}

export default PlayerCollapse